// DS: ?? (previously I120: Approved)
// from GDrive
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Success: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M12.137 21.637h-5.25v-5.25h5.25V.637h5.25v21h-5.25z"
        fill="#00e59b"
        fillRule="evenodd"
        transform="rotate(45 12.137 11.137)"
      />
    </svg>
  </IconWrap>
);
Success.displayName = 'Success';

export default Success;
